import React, { useState, useEffect, useRef } from 'react';
import {Button } from "reactstrap";

import Navbar from '../Navbar/Navbar';
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import Footer from "../Footer/Footer";

import Loader from '../../../loader';

import './Forms.css';
import parse from 'html-react-parser';

import * as Hosts from '../../../Hosts';
import {
    set_language,
    //reqGET,
	//reqPOST,
    //repo_banner_link,
    content_language,
    functionSendMail

} from '../../../Utils';


import { language } from '../WEBContent/Language';

import Swal from 'sweetalert2';

const ContactForm = (props) => {

    const data_interface = {
        id: '',
        info: {
            companycode: Hosts.companycode,
            name: '',
            email: '',
            subject: '',
            message: '',
            rgpd: false,    
        }

    }

    const [ , set_dados ] = useState( null ) ;
    const dados = useRef( data_interface ) ;

    const content_interface = {
        id: '',
        info: {},
        content: {}
    }
    const content = useRef(content_interface)


    const [lang, set_lang] = useState('pt');
    const [lang_id, set_lang_id] = useState('1');
    //const [data, setData] = useState([]);  
    const [isloading, setLoading] = useState(true) ;
    const [dados_config, set_dados_config] = useState({});
    const [navbar, set_navbar] = useState({});
    
    useEffect(() => {
        if(localStorage.getItem('lang') === undefined  || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_language('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if(el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }

        let getConfig = async () => {

            if(props.info !== undefined && props.info !== null && props.info !== '') {
                set_dados_config(props.info.state.dados_config)
                set_navbar(props.info.state.dados_navbar)
                set_dados(content.current = props.info.state.dados_content)
            }
        }

        /*let getInfo = async () => {

            await reqGET(`${Hosts.SIMCore_API}/web/content/slug/${Hosts.companycode}/contacts`)
                .then(res => { 
                    setData(res.data)
                    //console.log('CONTACTOS', res.data)
                    //setLoading(false)
    
                })
                .catch(erro => console.log('erro: ' + erro))  
    
        }
        getInfo()
        */
        (async () => {
            await getConfig()
      
            setLoading(false)
        })()
    
    }, [props.info]); 

    const [agree, setAgree] = useState(false);

    const checkboxHandler = () => {
      // if agree === true, it will be set to false
      // if agree === false, it will be set to true
      setAgree(!agree);
      // Don't miss the exclamation mark
    }

    const checkboxHandler_reload = (agree) => {
        //console.log('AGREE', agree)
        if (agree === true)
            return true
        else 
            return false
        // if agree === false, it will be set to true
        //setAgree(!agree);
        // Don't miss the exclamation mark
      }

    const [counterText, setCounterText] = useState('');

    const handle_change_info = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.info[name] = value)
        //console.log('Dados Current:' + JSON.stringify(dados))
    }

    const handle_change_info_textarea = (e) => {
        const { name, value } = e.target;
        //console.log('NAME ', name)
        //console.log('VALUE ', value)
        setCounterText(e.target.value)

        set_dados(dados.current.info[name] = value)
        //set_dados(dados.current.info.date.creation = new Date())
        //console.log('Dados Current:' + JSON.stringify(dados))
    }


    /*let mailOptions = {
        from: Hosts.contactFrom,
        // vários emails separados por virgulas
        to: dados.current.info.email,
        //to: 'suporte@assec.pt',

        //cc-> opcional
        cc: Hosts.contactFrom,
        subject: Hosts.webSiteTitle + ' - ' + language[lang].contact_form,
        //text: 'Teste de EMAIL ', -> opcional
        html:
            '<html><head></head><body style="background-color:#F7F7F7;">' +
                '<div style="width:100% !important;margin-top:0;margin-bottom:0;margin-right:0;margin-left:0;padding-top:0;padding-bottom:0;padding-right:0;padding-left:0;color:#425968;background-color:#F7F7F7;background-image:none;background-repeat:repeat;background-position:top left;background-attachment:scroll;font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:16px;">' +
                    '<table border="0" align="center" cellpadding="0" cellspacing="0" style="margin-top:0;margin-bottom:0;padding-top:0;padding-bottom:0;padding-right:0;padding-left:0;border-collapse:collapse;">' +
                        '<tr style="border-collapse: collapse;">' +
                            '<td style="border-collapse: collapse;">' +
                                '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; background-color:#ffffff;border:1px solid transparent;border-collapse:collapse;">' +
                                    '<tr style="border-collapse: collapse;">' +
                                        '<td align="left" class="logo" style="padding:0; border-collapse:collapse;">' +
                                            '<a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_SITE_URL + '" target="_blank" rel="noreferrer">' +
                                                '<img style="width: 600px; height: 90px;" width="600" height="90" src="' + repo_banner_link("banner-email.jpg") + '"/>' +
                                            '</a>'+
                                        '</td>' +
                                    '</tr>' +
                                '</table>' +
                                '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; padding: 15px 30px; background-color:#ffffff;border:1px solid transparent;border-collapse:collapse;">' +
                                    '<tr style="border-collapse: collapse;">' +
                                        '<td align="left" class style="padding:0 0 10px; border-collapse:collapse;">' +
                                            '<div style="width:540px; margin: 0 auto; padding: 15px 30px;">'+
                                                '<h4 style="text-transform: uppercase;font-family:Arial,Helvetica,sans-serif;">'+ language[lang].contact_form +':</h4>'+
                                                '<span style="font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:18px;"><b>'+ language[lang].name +': </b><label>' + dados.current.info.name + '</label></span>' +
                                                '<br/>'+
                                                '<span style="font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:18px;"><b>Email: </b><label>' + dados.current.info.email + '</label></span>'+
                                                '<br/>'+
                                                '<span style="font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:18px;"><b>'+ language[lang].subject +': </b><label>' + dados.current.info.subject + '</label></span>' +
                                                '<br/>'+
                                                '<br/>' +
                                                '<span style="font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:18px;"><b>'+ language[lang].message +': </b><label>' + dados.current.info.message + '</label></span>' +
                                                '<br/>'+
                                            '</div>'+
                                        '</td>' +
                                    '</tr>' +
                                '</table>' +
                                '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; background-color:' + Hosts.FOOTER_EMAIL_COLOR +'; padding: 10px; border:1px solid transparent;border-collapse:collapse;">' +
                                    '<tr style="border-collapse: collapse;">' +
                                        '<td align="left" style="padding:10px 0px; border-collapse:collapse;">' +
                                            '<div style="margin: 0 auto; width:600px;">'+
                                                '<div style="text-align: center; font-size: small; color: #FFFFFF;">'+
                                                    '<span style="text-transform: uppercase;font-family:Arial,Helvetica,sans-serif;font-size:12px;">' + Hosts.webSiteTitle + '</span>'+
                                                    '<br/>'+
                                                    '<span style="font-family:Arial,Helvetica,sans-serif;font-size:12px;">' + Hosts.webSiteAdress + '</span>'+
                                                    '<br/>'+
                                                    '<a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_SITE_URL + '" target="_blank" rel="noreferrer" style="font-family:Arial,Helvetica,sans-serif;text-decoration:none;"> '+
                                                        '<span style="color: #FFFFFF;font-family:Arial,Helvetica,sans-serif;font-size:12px;" >'+ Hosts.EMAIL_WEB_SITE_URL +'</span>' +
                                                    '</a>'+
                                                '</div>'+
                                            '</div>' +
                                        '</td>' +
                                    '</tr>' +
                                '</table>' +
                            '</td>' +
                        '</tr>' +
                    '</table>' +
                '</div>'+
            '<body><html>',

    };*/

    const handleSubmit = async e => {
        e.preventDefault();

        //alert('SUBMIT');
        //return;

        let contact_email_from = (dados_config.email_form !== undefined && dados_config.email_form !== '' ? dados_config.email_form : Hosts.contactFrom );

        let mail_content =  '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; padding: 15px 30px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR +';border:1px solid transparent;border-collapse:collapse;">' +
            '<tr style="border-collapse: collapse;">' +
                '<td align="left" class style="padding:40px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                    '<div>'+
                        '<h4>'+ language[lang].contact_form +':</h4>'+
                        '<span><b>'+ language[lang].name +': </b><label>' + dados.current.info.name + '</label></span>' +
                        '<br/>'+
                        '<span"><b>Email: </b><label>' + dados.current.info.email + '</label></span>'+
                        '<br/>'+
                        '<span><b>'+ language[lang].subject +': </b><label>' + dados.current.info.subject + '</label></span>' +
                        '<br/>'+
                        '<br/>' +
                        '<span><b>'+ language[lang].message +': </b><label>' + dados.current.info.message + '</label></span>' +
                        '<br/>'+
                    '</div>'+
                '</td>' +
            '</tr>' +
        '</table>'

        functionSendMail(contact_email_from, [dados.current.info.email], [contact_email_from], Hosts.webSiteTitle + ' - ' + language[lang].contact_form, mail_content, [])
            .then((res) => {
                if(res === true) {
                    set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
                    document.getElementById('agree').checked = false
                    setAgree(false)
                    //setRefresh(refresh + 1)
                    Swal.fire({
                        title: language[lang].contact_form,
                        text: language[lang].sent_successfully,
                        icon: 'success',
                        //showCancelButton: true,
                        confirmButtonColor: '#08396a',
                        //confirmButtonText: 'Tentar novamente',
                        })
                }
                else {
                    console.log('erro')
                }
            })


        /*reqPOST(`${Hosts.SIMCore_API_MAIL}`, {data: mailOptions})
            .then(() => { 
                //console.log('Notificações enviadas com sucesso') 
                set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
                document.getElementById('agree').checked = false
                //setAgree(false)
                //setRefresh(refresh + 1)
                Swal.fire({
                    title: language[lang].contact_form,
                    text: language[lang].sent_successfully,
                    icon: 'success',
                    //showCancelButton: true,
                    confirmButtonColor: '#08396a',
                    //confirmButtonText: 'Tentar novamente',
                  })
        
            })
            .catch((error) => console.log(error)//alert('Problema ao enviar notificações!'))*/

    }

    return(
        isloading ?
		    <Loader />
        :
            <>

                <Navbar dados_config={dados_config} dados_navbar={navbar} />
                <Breadcrumb dados_config={dados_config.current} dados_navbar={navbar} dados_content={content.current} />
                <main className="contacts">
                    <div className="container my-5">
                        <div className="row">
                            <div className="col-12 col-md-5">
                                <div className='info-container'>
                                    <div className='title-properties text-start'>
                                        <h1 className="titulo-pp">
                                            {lang === 'pt' || content.current.content[0].language === undefined ? content.current.content[0].title : (content.current.content[0].language[lang_id] === undefined || content.current.content[0].language[lang_id].title === undefined || content.current.content[0].language[lang_id].title === '' ? content.current.content[0].title : content.current.content[0].language[lang_id].title)}
                                        </h1>
                                        { 
                                            content.current.content[0].subtitle !== '' ?
                                                <h2 className="subtitulo-pp">
                                                    {lang === 'pt' || content.current.content[0].language === undefined ? content.current.content[0].subtitle : (content.current.content[0].language[lang_id] === undefined || content.current.content[0].language[lang_id].subtitle === undefined || content.current.content[0].language[lang_id].subtitle === '' ? content.current.content[0].subtitle : content.current.content[0].language[lang_id].subtitle)}
                                                </h2>

                                            :
                                                null
                                        }
                                        <hr></hr>
                                    </div>
                                    { 
                                        content.current.content[0].text !== '' && content.current.content[0].text !== '<p></p>\n' ?
                                            <div className='contact-text'>
                                                {parse(lang === 'pt' || content.current.content[0].language === undefined ? content.current.content[0].text : (content.current.content[0].language[lang_id] === undefined || content.current.content[0].language[lang_id].text === undefined || content.current.content[0].language[lang_id].text === '' || content.current.content[0].language[lang_id].text === '<p></p>\n' ? content.current.content[0].text : content.current.content[0].language[lang_id].text))}
                                            </div>
                                        :
                                            null 
                                        } 
                                </div>
                            </div>
                            <div className="col-12 col-md-7 mt-5 mt-md-0">
                                <form className='form-container' onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-12">
                                            <p>
                                                {language[lang].read_terms_conditions}
                                                {/*Leia os nossos <a href={Hosts.WEB_SITE_URI + "terms_conditions"} target="_blank" rel="noreferrer">termos e condições</a> antes de submeter o formulário. Ao submeter concorda com os termos do nosso serviço.*/}
                                            </p>
                                        </div>
                                        <div className="col-12 col-sm-6 mb-3">
                                            <label className="form-label visually-hidden" htmlFor="name">{language[lang].name}*</label>
                                            <input id="name" type="text" name="name" value={dados.current.info.name} className="form-control" placeholder={language[lang].name + " *"} onChange={handle_change_info} required />
                                        </div>
                                        <div className="col-12 col-sm-6 mb-3">
                                            <label className="form-label visually-hidden" htmlFor="email">{language[lang].email}*</label>
                                            <input id="email" type="email" name="email" 
                                                value={dados.current.info.email} 
                                                className="form-control" 
                                                placeholder={language[lang].email + " *"} 
                                                onChange={handle_change_info} required
                                            /> 
                                        </div>
                                        
                                        <div className="col-12 mb-3">
                                            <label className="form-label visually-hidden" htmlFor="subject">{language[lang].subject}*</label>
                                            <input id="subject" type="subject" name="subject" 
                                                value={dados.current.info.subject} 
                                                className="form-control" 
                                                placeholder={language[lang].subject + " *"} 
                                                onChange={handle_change_info} required
                                            /> 
                                        </div> 
                                        <div className="col-12">
                                        <label className="form-label visually-hidden" htmlFor="message">{language[lang].message}*</label>
                                            <textarea
                                                style={{ height: "180px", width: "100%" }}
                                                id="message"
                                                name="message"
                                                className="form-control"
                                                placeholder={language[lang].message + " *"}
                                                maxLength="600"
                                                value={dados.current.info.message}
                                                onChange={handle_change_info_textarea}
                                                required
                                            />
                                            <div className="text-end fw-bold my-2 small">
                                                {language[lang].maximum_numbers_of_caracters}&#58;&nbsp;{counterText.length}/600
                                            </div>
                                            {/* <TextareaCounter countLimit={200} style={{height: "100px", width: "100%"}} id="message" name="message" value={dados.current.info.message} onChange={handle_change_info} required/>
                                            <input type="text" name="message" value={dados.current.info.message} className="form-control" placeholder="" onChange={handle_change_info} /> */}
                                        </div>

                                        <div className="col-12">
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox" id="agree" onChange={checkboxHandler} defaultChecked={checkboxHandler_reload(agree)}/>
                                                <label className="form-check-label" htmlFor="agree">{language[lang].agree_terms_conditions}</label>&nbsp;
                                                <a href={Hosts.WEB_SITE_URI + "terms-conditions"} target="_blank" rel="noreferrer">{language[lang].terms_conditions_link}</a>
                                            </div>
                                            <label className="small" htmlFor="agree">{language[lang].terms_conditions_required}</label>
                                        </div>
                                        <div className='col-12 text-end mt-5'>
                                            {/*{console.log('AGREE2', agree)}
                                            {console.log('MAIL: ', JSON.stringify(mailOptions))}*/}
                                            <Button disabled={!agree} className="mx-auto" color="primary">{language[lang].send}</Button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    {
                       dados_config.gps_lat !== undefined && dados_config.gps_lat !== '' && dados_config.gps_lng !== undefined && dados_config.gps_lng !== '' ?
                            <div className="mapouter">
                                <div className="gmap_canvas">
                                    <iframe width="100%" height="500" id="gmap_canvas" title="gmap_canvas" src={"https://maps.google.com/maps?q=" + dados_config.gps_lat + "," + dados_config.gps_lng + "&hl=pt&z=18&maptype=satellite&output=embed"} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                                </div>
                            </div>
                        :
                         null
                    }
                </main>
                <Footer dados_config={dados_config} dados_navbar={navbar} />

            </>
    );
};

export default ContactForm;